import { defineComponent as _defineComponent } from 'vue'
import { computed, inject, ref } from 'vue';

import {
  NavBar,
  SpinnerLoader,
  ChipStatus,
  Grid,
  ButtonContainer,
  ButtonPrimary
} from '@warrenbrasil/nebraska-web';
import { BackButton } from '@/modules/common/components/buttons/BackButton';
import { Details } from './components/Details';
import { Allocation } from './components/Allocation';
import { Products } from './components/Products';
import { PortfolioNameModal } from './components/PortfolioNameModal';

import { ESuggestedPortfolioBuilderSteps } from '@/modules/wealth/views/SuggestedPortfolioBuilder/helpers';
import { IGetSuggestedPortfolioDetailsResponse } from '@/modules/wealth/services/suggested-portfolio-builder';


export default /*#__PURE__*/_defineComponent({
  __name: 'PortfolioDetails',
  setup(__props) {

const changeStep = inject(
  'changeStep',
  (step: ESuggestedPortfolioBuilderSteps) => ({ step })
);
const confirmDetails = inject('confirmDetails', (portfolioName: string) => ({
  portfolioName
}));

const isLoading = inject('isLoading') as boolean;
const isDetailsLoading = inject('isDetailsLoading') as boolean;
const suggestedPortfolioDetailsInject = inject(
  'suggestedPortfolioDetails'
) as IGetSuggestedPortfolioDetailsResponse;

const suggestedPortfolioDetails = ref(suggestedPortfolioDetailsInject);
const isPortfolioNameModalOpen = ref(false);

const parseCategories = computed(() => {
  return suggestedPortfolioDetails.value.categories.filter(
    category => category.allocValue.value > 0
  );
});

function handlePortfolioNameModal() {
  isPortfolioNameModalOpen.value = !isPortfolioNameModalOpen.value;
}

function savePortfolioName(portfolioName: string) {
  confirmDetails(portfolioName);
  handlePortfolioNameModal();
}

function back() {
  changeStep(ESuggestedPortfolioBuilderSteps.PORTFOLIO_SELECT);
}

return { __sfc: true,changeStep, confirmDetails, isLoading, isDetailsLoading, suggestedPortfolioDetailsInject, suggestedPortfolioDetails, isPortfolioNameModalOpen, parseCategories, handlePortfolioNameModal, savePortfolioName, back, NavBar, SpinnerLoader, ChipStatus, Grid, ButtonContainer, ButtonPrimary, BackButton, Details, Allocation, Products, PortfolioNameModal }
}

})